

export interface InspectionIssueAttachment {
  fileName: string;
  fileUrl: string;
  bucketPath: string;
  bucketName: string;
  fileType: string;
  fileSizeBytes: number;
}

export interface CreateInspectionIssueRequest {
  inspectionItemId: string;
  type: number;
  issueTypeId?: string;
  title: string;
  description: string;
  targetRole?: string;
  attachments?: InspectionIssueAttachment[];
}

export interface CreateInspectionIssueResponse {
  success: boolean;
  message: string;
  data?: {
    id: string;
  };
}

export interface ResolveInspectionIssueRequest {
  resolutionNotes: string;
}

export interface ResolveInspectionIssueResponse {
  success: boolean;
  message: string;
}

export interface AddIssueCommentRequest {
  comment: string;
  isInternal: boolean;
}

export interface AddIssueCommentResponse {
  success: boolean;
  message: string;
}

export interface InspectionIssueComment {
  id: string;
  inspectionIssueId: string;
  comment: string;
  commentedBy: string;
  commentedByName: string;
  commentedAt: string;
  isInternal: boolean;
}

export interface InspectionIssue {
  id: string;
  inspectionItemId: string;
  type: number;
  typeDescription: string;
  issueTypeId?: string;
  issueTypeName?: string;
  title: string;
  description: string;
  targetRole: string;
  status: number;
  statusDescription: string;
  reportedBy: string;
  reportedByName: string;
  reportedAt: string;
  resolvedBy?: string;
  resolvedByName?: string;
  resolvedAt?: string;
  resolutionNotes?: string;
  attachments: InspectionIssueAttachment[];
  comments: InspectionIssueComment[];
  createdAt: string;
}

export interface GetInspectionIssuesParams {
  inspectionItemId: string;
}

export enum InspectionIssueType {
  // Inspetor → Prestadora
  DificuldadeAgendamento = 1,
  ContatoNaoResponde = 2,
  EnderecoIncorreto = 3,
  DocumentacaoIncompleta = 4,
  AcessoNegado = 5,
  ImovelIndisponivel = 6,

  // Prestadora → Banco
  DuvidaLaudo = 10,
  PendenciaDocumental = 11,
  SolicitacaoReavaliacao = 12,

  // Banco → Prestadora
  CorrecaoNecessaria = 20,
  InformacaoAdicional = 21,

  Outros = 99,
}

export const InspectionIssueTypeLabels: Record<number, string> = {
  [InspectionIssueType.DificuldadeAgendamento]: "Dificuldade de Agendamento",
  [InspectionIssueType.ContatoNaoResponde]: "Contato Não Responde",
  [InspectionIssueType.EnderecoIncorreto]: "Endereço Incorreto",
  [InspectionIssueType.DocumentacaoIncompleta]: "Documentação Incompleta",
  [InspectionIssueType.AcessoNegado]: "Acesso Negado",
  [InspectionIssueType.ImovelIndisponivel]: "Imóvel Indisponível",
  [InspectionIssueType.DuvidaLaudo]: "Dúvida sobre Laudo",
  [InspectionIssueType.PendenciaDocumental]: "Pendência Documental",
  [InspectionIssueType.SolicitacaoReavaliacao]: "Solicitação de Reavaliação",
  [InspectionIssueType.CorrecaoNecessaria]: "Correção Necessária",
  [InspectionIssueType.InformacaoAdicional]: "Informação Adicional",
  [InspectionIssueType.Outros]: "Outros",
};

// Tipos disponíveis por papel
export const InspectorIssueTypes = [
  InspectionIssueType.DificuldadeAgendamento,
  InspectionIssueType.ContatoNaoResponde,
  InspectionIssueType.EnderecoIncorreto,
  InspectionIssueType.DocumentacaoIncompleta,
  InspectionIssueType.AcessoNegado,
  InspectionIssueType.ImovelIndisponivel,
  InspectionIssueType.Outros,
];

export const ProviderIssueTypes = [
  InspectionIssueType.DuvidaLaudo,
  InspectionIssueType.PendenciaDocumental,
  InspectionIssueType.SolicitacaoReavaliacao,
  InspectionIssueType.Outros,
];

export const BankIssueTypes = [
  InspectionIssueType.CorrecaoNecessaria,
  InspectionIssueType.InformacaoAdicional,
  InspectionIssueType.Outros,
];

